var map = {
	"./staging_holiday_promo_23d_fallback.json": [
		43645,
		3645
	],
	"./staging_holiday_promo_3_fallback.json": [
		46048,
		6048
	],
	"./staging_holiday_promo_fallback.json": [
		3927,
		3927
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 25096;
module.exports = webpackAsyncContext;